import { jsx as _jsx } from "react/jsx-runtime";
import VantageLink from "../../../atoms/VantageLink";
export var stepLinksArray = [
    {
        annualCreditLink: (_jsx(VantageLink, { to: "//www.annualcreditreport.com", isExternal: true, fromModal: true, id: "questions-modal-annual-credit-report" })),
    },
    // Second step has no links in it
    {},
    {
        transUnionLink: (_jsx(VantageLink, { to: "//dispute.transunion.com", isExternal: true, fromModal: true, id: "questions-modal-transunion-dispute" })),
        transUnionPhoneNumber: (_jsx(VantageLink, { to: "tel:8009168800", isExternal: true, fromModal: true, id: "questions-modal-transunion-phone-number" })),
    },
];
export default stepLinksArray;
